<template lang="pug">
    .main-content-padded
        .vspace.large
        .row
            .col.s12
                .bcrumb
                    router-link(:to='{path: "/products"}') Products
                    a(v-if='$router.currentRoute.name === "products-upload"') Upload
        router-view
</template>
<script>
export default {
  meta: {
    title: 'Products'
  }
}
</script>



// WEBPACK FOOTER //
// src/components/page-products.vue